export default __webpack_public_path__ + "static/media/client_first2.f1cfaa03.png";